import React, { Fragment } from 'react'
import { StyledAudioElement } from '../styled'

export const AudioPlayer = ({audioData}) => {
  return (
    <Fragment>
        {audioData.map((d, i) => (
            <StyledAudioElement
            key={`${i-d}`}
            controls
            src={d.publicUrl}
            controlsList="nodownload noplaybackrate" // to hide controls
            ></StyledAudioElement>
         ))}
    </Fragment>
  )
}
